// extracted by mini-css-extract-plugin
export default {"details-container":"style_details-container__5smOP","detail":"style_detail__d-ivG","label":"style_label__8X5GQ","value":"style_value__hREKH"};